import { createStore } from 'vuex'

export default createStore({
  state: {
    token: localStorage.getItem('token') || '',
    user: JSON.parse(localStorage.getItem('user') || '{}'),
    isLoading: false,
    notification: {
      show: false,
      type: 'success',
      message: ''
    }
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER(state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },
    CLEAR_AUTH(state) {
      state.token = ''
      state.user = {}
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    },
    SET_LOADING(state, isLoading) {
      state.isLoading = isLoading
    },
    SHOW_NOTIFICATION(state, { type, message }) {
      state.notification = { show: true, type, message }
    },
    HIDE_NOTIFICATION(state) {
      state.notification.show = false
    }
  },
  actions: {
    login({ commit }, { token, user }) {
      commit('SET_TOKEN', token)
      commit('SET_USER', user)
    },
    logout({ commit }) {
      commit('CLEAR_AUTH')
    },
    showNotification({ commit }, { type, message }) {
      commit('SHOW_NOTIFICATION', { type, message })
      setTimeout(() => {
        commit('HIDE_NOTIFICATION')
      }, 3000)
    }
  },
  getters: {
    isAuthenticated: state => !!state.token,
    isAdmin: state => state.user.role === 'super_admin' || state.user.role === 'review_admin',
    isDesigner: state => ['designer', 'review_admin', 'super_admin'].includes(state.user.role),
    isPending: state => state.user.role === 'pending',
    currentUser: state => state.user
  }
})
